import { atom } from 'recoil';

export const demoModeAtom = atom<boolean>({
    key: 'demoModeAtom',
    default: false,
});